<div class="docs-page">

  <!-- ── Announcement: scrolls away; the top bar below stays. ───── -->
  @if (announcement; as a) {
    <div class="docs-announcement" role="region" aria-label="Announcement">
      <p class="docs-announcement__text">
        {{ a.text }}
        <a class="docs-announcement__link" [routerLink]="a.link">{{ a.linkLabel }}<span aria-hidden="true"> →</span></a>
      </p>
      <button type="button" class="docs-announcement__close" (click)="dismissAnnouncement()" aria-label="Dismiss announcement">
        <svg width="14" height="14" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M3 3l6 6M9 3l-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
      </button>
    </div>
  }

  <!-- ── Top bar ─────────────────────────────────────────────── -->
  <header class="docs-topbar" [class.docs-topbar--scrolled]="scrolled">
    <div class="docs-topbar__inner">
      <!-- Phones only (see _docs.scss): opens the sidebar as a drawer. -->
      <button type="button" class="docs-topbar__menu" aria-label="Open docs menu" aria-controls="docs-nav"
              [attr.aria-expanded]="navOpen" (click)="openNav()">
        <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2 4H14M2 8H14M2 12H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
      <a class="docs-topbar__brand" routerLink="/docs">
        <svg class="docs-topbar__logo" viewBox="0 0 528 160.442" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="-mila.">
          <path id="dash" d="M0 83.8674H72.9282V108.663H0V83.8674Z" fill="currentColor"/>
          <path id="m" d="M87.5138 157.525V94.8066C87.5138 67.0939 109.392 45.9447 137.105 45.9447C151.691 45.9447 164.818 51.779 173.569 61.2596C182.32 51.779 195.447 45.9447 211.492 45.9447C237.746 45.9447 256.707 65.6353 256.707 93.348V157.525H230.453V93.348C230.453 80.2209 222.431 71.4696 210.033 71.4696C196.906 71.4696 185.238 80.2209 185.238 93.348V157.525H158.983V93.348C158.983 80.2209 150.232 71.4696 137.105 71.4696C123.978 71.4696 113.768 80.2209 113.768 94.8066V131.271C113.768 145.856 102.099 157.525 87.5138 157.525Z" fill="currentColor"/>
          <path id="i-stem" d="M272.022 157.525V52.5083C272.022 50.3205 273.481 48.8619 275.669 48.8619H291.713C295.359 48.8619 298.276 51.7791 298.276 55.4255V157.525H272.022Z" fill="currentColor"/>
          <path id="i-dot" d="M301.923 16.7735C301.923 26.2541 294.63 33.547 285.149 33.547C275.669 33.547 268.376 26.2541 268.376 16.7735C268.376 7.29282 275.669 0 285.149 0C294.63 0 301.923 7.29282 301.923 16.7735Z" fill="currentColor"/>
          <path id="l" d="M315.05 2.91711H329.635C336.199 2.91711 341.304 8.02209 341.304 14.5856V157.525H315.05V2.91711Z" fill="currentColor"/>
          <path id="a" fill-rule="evenodd" clip-rule="evenodd" d="M471.845 157.525H446.32V138.563C436.84 151.691 423.713 158.983 405.481 158.983C375.58 158.983 353.702 134.188 353.702 103.558C353.702 70.7403 379.227 45.9447 413.503 45.9447C447.05 45.9447 471.845 69.2817 471.845 102.099V157.525ZM445.591 102.829C445.591 85.3259 431.735 71.4696 413.503 71.4696C395.271 71.4696 380.685 85.3259 380.685 102.829C380.685 121.061 394.541 134.188 412.773 134.188C431.006 134.188 445.591 120.331 445.591 102.829Z" fill="currentColor"/>
          <path id="terminal-dot" d="M508.309 121.79C520.707 121.79 527.271 128.354 527.271 140.022V141.481C527.271 153.149 520.707 158.983 508.309 158.983C495.912 158.983 489.348 153.149 489.348 141.481V140.022C489.348 128.354 495.912 121.79 508.309 121.79Z" fill="#FF7700"/>
        </svg>
        <span class="docs-topbar__badge">DOCS</span>
        <span class="docs-topbar__version">v1</span>
      </a>

      <button type="button" class="docs-topbar__search" (click)="openSearch()" aria-label="Search the docs">
        <svg width="15" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <circle cx="7" cy="7" r="5.25" stroke="currentColor" stroke-width="1.5"/>
          <path d="M14 14L11 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <span>Search the docs&hellip;</span>
        <kbd>&#8984;K</kbd>
      </button>

      <nav class="docs-topbar__nav">
        <a routerLink="/docs/api-reference" routerLinkActive="docs-topbar__link--active">API Reference</a>
        <a routerLink="/docs" routerLinkActive="docs-topbar__link--active" [routerLinkActiveOptions]="{exact: true}">Guides</a>
        <a routerLink="/docs/changelog" routerLinkActive="docs-topbar__link--active">Changelog</a>
      </nav>

      <button
        type="button"
        class="docs-theme-toggle"
        (click)="docsTheme.toggle()"
        [attr.aria-label]="docsTheme.isLight() ? 'Switch to dark mode' : 'Switch to light mode'"
        [attr.aria-pressed]="docsTheme.isLight()"
        title="Toggle light / dark theme"
      >
        <!-- Sun: shown in dark mode, offers switching to light -->
        @if (!docsTheme.isLight()) {
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="8" cy="8" r="3.5" stroke="currentColor" stroke-width="1.4"/>
            <path d="M8 0.75V2.5M8 13.5V15.25M15.25 8H13.5M2.5 8H0.75M13.06 2.94L11.83 4.17M4.17 11.83L2.94 13.06M13.06 13.06L11.83 11.83M4.17 4.17L2.94 2.94" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
          </svg>
        } @else {
          <!-- Moon: shown in light mode, offers switching back to dark -->
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M14.2 9.63A6.25 6.25 0 116.37 1.8a5 5 0 007.83 7.83Z" fill="currentColor"/>
          </svg>
        }
      </button>
    </div>
  </header>

  <div class="docs-body">

    <!-- ── Sidebar ─────────────────────────────────────────────── -->
    <nav class="docs-nav" id="docs-nav" [class.docs-nav--open]="navOpen" aria-label="Docs">

      <div class="docs-nav__section">
        <span class="docs-nav__label">Get started</span>
        <a class="docs-nav__item" routerLink="/docs" routerLinkActive="docs-nav__item--active" [routerLinkActiveOptions]="{exact: true}">
          <svg class="docs-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 7v14"/><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"/></svg>
          Introduction
        </a>
        <a class="docs-nav__item" routerLink="/docs/quickstart" routerLinkActive="docs-nav__item--active">
          <svg class="docs-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"/></svg>
          Quickstart
        </a>
        <a class="docs-nav__item" routerLink="/docs/authentication" routerLinkActive="docs-nav__item--active">
          <svg class="docs-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z"/><circle cx="16.5" cy="7.5" r=".5" fill="currentColor"/></svg>
          Authentication
        </a>
      </div>

      <div class="docs-nav__section">
        <span class="docs-nav__label">Guides</span>
        <a class="docs-nav__item" routerLink="/docs/making-a-call" routerLinkActive="docs-nav__item--active">
          <svg class="docs-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          Making a call
        </a>
        <a class="docs-nav__item" routerLink="/docs/pricing-limits" routerLinkActive="docs-nav__item--active">
          <svg class="docs-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="8" r="6"/><path d="M18.09 10.37A6 6 0 1 1 10.34 18"/><path d="M7 6h1v4"/><path d="m16.71 13.88.7.71-2.82 2.82"/></svg>
          Pricing &amp; limits
        </a>
        <a class="docs-nav__item" routerLink="/docs/errors" routerLinkActive="docs-nav__item--active">
          <svg class="docs-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>
          Errors
        </a>
        <a class="docs-nav__item" routerLink="/docs/account-filters" routerLinkActive="docs-nav__item--active">
          <svg class="docs-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z"/></svg>
          Account &amp; filters
        </a>
      </div>

      <div class="docs-nav__divider"></div>

      <div class="docs-nav__section">
        <span class="docs-nav__label">API reference</span>
        <a class="docs-nav__item" routerLink="/docs/api-reference" routerLinkActive="docs-nav__item--active" [routerLinkActiveOptions]="{exact: true}">
          All endpoints
        </a>
        @for (ep of endpoints; track ep.id) {
          <div class="docs-nav__endpoint">
            <a class="docs-nav__item docs-nav__item--endpoint" [routerLink]="['/docs/api-reference', ep.id]" routerLinkActive="docs-nav__item--active">
              <span class="endpoint-badge endpoint-badge--post">POST</span>
              {{ ep.label }}
              <button type="button" class="docs-nav__chevron" [class.docs-nav__chevron--open]="expanded[ep.id]" (click)="toggleEndpoint(ep.id); $event.preventDefault(); $event.stopPropagation()" [attr.aria-label]="(expanded[ep.id] ? 'Collapse' : 'Expand') + ' ' + ep.label">
                <svg width="10" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
            </a>
            <!-- Always rendered rather than @if'd out the grid-rows trick
                 below animates the collapse instead of cutting it instantly,
                 and [attr.inert] keeps the hidden links out of the tab
                 order (and off-screen readers) while collapsed, since
                 they're still in the DOM for that transition to run on. -->
            <div class="docs-nav__subitems-wrap" [class.docs-nav__subitems-wrap--open]="expanded[ep.id]" [attr.inert]="expanded[ep.id] ? null : ''">
              <div class="docs-nav__subitems">
                <!-- activeTocId is the same scroll-spied id the "Contents"
                     rail uses (see docs-layout.ts's updateActiveToc) these
                     fragments target the exact same docs-h2 ids, so no
                     separate tracking is needed here. Request also lights
                     up for the Cikisi-only h3 nested under it (see
                     DocsApiReferenceDetail), which has no subitem of its
                     own. -->
                <a class="docs-nav__subitem" [class.docs-nav__subitem--active]="activeTocId === ep.id + '-request' || activeTocId === ep.id + '-request-cikisi'" [routerLink]="['/docs/api-reference', ep.id]" fragment="{{ ep.id }}-request">Request</a>
                <a class="docs-nav__subitem" [class.docs-nav__subitem--active]="activeTocId === ep.id + '-response'" [routerLink]="['/docs/api-reference', ep.id]" fragment="{{ ep.id }}-response">Response</a>
                <a class="docs-nav__subitem" [class.docs-nav__subitem--active]="activeTocId === ep.id + '-example'" [routerLink]="['/docs/api-reference', ep.id]" fragment="{{ ep.id }}-example">Example</a>
                <a class="docs-nav__subitem" [class.docs-nav__subitem--active]="activeTocId === ep.id + '-schemas'" [routerLink]="['/docs/api-reference', ep.id]" fragment="{{ ep.id }}-schemas">Schemas</a>
              </div>
            </div>
          </div>
        }
      </div>

      <div class="docs-nav__spacer"></div>

      <div class="docs-nav__footer">
        <a class="docs-nav__footer-link" routerLink="/docs/changelog">
          <svg width="13" height="13" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1a7 7 0 100 14A7 7 0 008 1Zm.75 3.5a.75.75 0 00-1.5 0v4c0 .2.08.39.22.53l2.5 2.5a.75.75 0 101.06-1.06L8.75 8.19V4.5Z" fill="currentColor"/></svg>
          Changelog
        </a>
      </div>

      <a class="docs-nav__cta" routerLink="/api-keys/create" target="_blank" rel="noopener">
        <p class="docs-nav__cta-title">Ready to try -mila?</p>
        <p class="docs-nav__cta-desc">Get your API key and start building today.</p>
        <span class="docs-nav__cta-btn">Get API Key <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4.5 2.5L8 6L4.5 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
      </a>
    </nav>

    <div class="docs-nav-backdrop" [class.docs-nav-backdrop--open]="navOpen" aria-hidden="true" (click)="closeNav()"></div>

    <!-- ── Routed content ──────────────────────────────────────── -->
    <!-- No (scroll) binding this no longer scrolls itself, the page
         does (see DocsLayout's window:scroll listener). #docsScroll is
         still used to query the routed page's own headings for the TOC. -->
    <div class="docs-content" #docsScroll>
      <!-- Phones: the Contents rail folds into this, above the page. -->
      @if (tocItems.length) {
        <details class="docs-toc-mobile" #tocMobile>
          <summary class="docs-toc-mobile__summary">On this page</summary>
          <nav class="docs-toc-mobile__list" aria-label="On this page">
            @for (item of tocItems; track item.id) {
              <a
                class="docs-toc__link"
                [class.docs-toc__link--sub]="item.level === 3"
                [class.docs-toc__link--active]="activeTocId === item.id"
                [href]="'#' + item.id"
                (click)="tocMobile.open = false; onTocLinkClick($event, item.id)"
              >{{ item.label }}</a>
            }
          </nav>
        </details>
      }
      <router-outlet></router-outlet>

      @if (prevPage || nextPage) {
        <nav class="docs-pagination" aria-label="Docs pagination">
          @if (prevPage) {
            <a class="docs-pagination__link docs-pagination__link--prev" [routerLink]="prevPage.path">
              <span class="docs-pagination__dir">&larr; Previous</span>
              <span class="docs-pagination__title">{{ prevPage.label }}</span>
            </a>
          }
          @if (nextPage) {
            <a class="docs-pagination__link docs-pagination__link--next" [routerLink]="nextPage.path">
              <span class="docs-pagination__dir">Next &rarr;</span>
              <span class="docs-pagination__title">{{ nextPage.label }}</span>
            </a>
          }
        </nav>
      }
    </div>

    <!-- ── Contents ────────────────────────────────────────────── -->
    @if (tocItems.length) {
      <aside class="docs-toc">
        <span class="docs-toc__label">
          <svg width="13" height="13" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M2.5 4.5h11M2.5 8h7.5M2.5 11.5h7.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
          Contents
        </span>
        <nav class="docs-toc__list">
          @for (item of tocItems; track item.id) {
            <a
              class="docs-toc__link"
              [class.docs-toc__link--sub]="item.level === 3"
              [class.docs-toc__link--active]="activeTocId === item.id"
              [href]="'#' + item.id"
              (click)="onTocLinkClick($event, item.id)"
            >{{ item.label }}</a>
          }
        </nav>
      </aside>
    }

  </div>

</div>
